export default function IconPrintText({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M6.01074 7.00879V1.01855H15.5811C15.8459 1.01861 16.0998 1.12383 16.287 1.31108L18.6971 3.72115C18.8844 3.90833 18.9895 4.16224 18.9896 4.427V7.00879H6.01074Z"
        fill="white"
      />
      <path d="M18.9896 5.01172H6.01074V7.00846H18.9896V5.01172Z" fill="#E4F1F5" />
      <path
        d="M3.0153 16.9925C2.48621 16.9909 1.97926 16.7801 1.60513 16.406C1.23101 16.0318 1.02014 15.5248 1.01855 14.9958V9.00553C1.02014 8.47645 1.23101 7.96949 1.60513 7.59536C1.97926 7.22124 2.48621 7.01037 3.0153 7.00879H21.9844C22.5134 7.01037 23.0204 7.22124 23.3946 7.59536C23.7687 7.96949 23.9795 8.47645 23.9811 9.00553V14.9958C23.9795 15.5248 23.7687 16.0318 23.3946 16.406C23.0204 16.7801 22.5134 16.9909 21.9844 16.9925H3.0153Z"
        fill="#86EFAC"
      />
      <path
        d="M18.9896 22.9834C18.9896 23.2482 18.8844 23.5022 18.6972 23.6893C18.51 23.8765 18.256 23.9818 17.9912 23.9818H7.00911C6.74433 23.9818 6.49039 23.8765 6.30316 23.6893C6.11593 23.5022 6.01074 23.2482 6.01074 22.9834V13.998H18.9896V22.9834Z"
        fill="white"
      />
      <path d="M18.9896 13.998H6.01074V15.9948H18.9896V13.998Z" fill="#E4F1F5" />
      <path
        d="M21.9844 7.00879H3.0153C2.48621 7.01037 1.97926 7.22124 1.60513 7.59536C1.23101 7.96949 1.02014 8.47645 1.01855 9.00553V11.0023C1.02014 10.4732 1.23101 9.96624 1.60513 9.59211C1.97926 9.21799 2.48621 9.00711 3.0153 9.00553H21.9844C22.5134 9.00711 23.0204 9.21799 23.3946 9.59211C23.7687 9.96624 23.9795 10.4732 23.9811 11.0023V9.00553C23.9795 8.47645 23.7687 7.96949 23.3946 7.59536C23.0204 7.22124 22.5134 7.01037 21.9844 7.00879Z"
        fill="#DCFCE7"
      />
      <path
        d="M18.9896 4.427C18.9895 4.16224 18.8844 3.90833 18.6971 3.72115L16.287 1.31108C16.0998 1.12383 15.8459 1.01861 15.5811 1.01855H14.9961V5.01204H18.9896V4.427Z"
        fill="#E4F1F5"
      />
      <path
        d="M6.01042 16.9925H3.0153C2.48621 16.9909 1.97926 16.7801 1.60513 16.406C1.23101 16.0318 1.02014 15.5248 1.01855 14.9958V9.00553C1.02014 8.47645 1.23101 7.96949 1.60513 7.59536C1.97926 7.22124 2.48621 7.01037 3.0153 7.00879H21.9844C22.5134 7.01037 23.0204 7.22124 23.3946 7.59536C23.7687 7.96949 23.9795 8.47645 23.9811 9.00553V14.9958C23.9795 15.5248 23.7687 16.0318 23.3946 16.406C23.0204 16.7801 22.5134 16.9909 21.9844 16.9925H18.9893"
        stroke="#191919"
        strokeWidth="1.03906"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9896 22.9834C18.9896 23.2482 18.8844 23.5022 18.6972 23.6893C18.51 23.8765 18.256 23.9818 17.9912 23.9818H7.00911C6.74433 23.9818 6.49039 23.8765 6.30316 23.6893C6.11593 23.5022 6.01074 23.2482 6.01074 22.9834V13.998H18.9896V22.9834Z"
        stroke="#191919"
        strokeWidth="1.03906"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00684 19.9883H16.9922"
        stroke="#191919"
        strokeWidth="1.03906"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00684 16.9922H16.9922"
        stroke="#191919"
        strokeWidth="1.03906"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.01074 5.01204V1.01855H15.5811C15.8459 1.01861 16.0998 1.12383 16.287 1.31108L18.6971 3.72115C18.8844 3.90833 18.9895 4.16224 18.9896 4.427V5.01204"
        stroke="#191919"
        strokeWidth="1.03906"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.014 11.0026C4.21146 11.0026 4.40448 10.9441 4.56866 10.8344C4.73285 10.7247 4.86081 10.5687 4.93637 10.3863C5.01194 10.2039 5.03171 10.0031 4.99319 9.80946C4.95466 9.61579 4.85958 9.4379 4.71996 9.29827C4.58032 9.15865 4.40243 9.06356 4.20877 9.02505C4.01511 8.98652 3.81436 9.00629 3.63194 9.08186C3.44951 9.15742 3.29358 9.28538 3.18388 9.44957C3.07418 9.61375 3.01562 9.80677 3.01562 10.0042C3.01562 10.269 3.12081 10.523 3.30804 10.7102C3.49527 10.8974 3.74921 11.0026 4.014 11.0026Z"
        fill="#FF808C"
        stroke="#191919"
        strokeWidth="1.03906"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9961 1.01855V5.01204H18.9896"
        stroke="#191919"
        strokeWidth="1.03906"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
